import { TComponentType } from '@/helpers/editor';
import moment, { Moment } from 'moment';
import { EUserAdEvent } from './user';

export interface ITab {
  name: string;
  value: string;
  icon?: string;
}

export interface ISelector {
  value: TComponentType | string | number;
  label: string | number;
  iconClass?: string;
  disabled?: boolean;
  $isDisabled?: boolean;
}

export interface IOriginSelector extends ISelector {
  ping: number;
  url?: string;
  value: string;
  label: string;
}

export interface ISelectorGroup {
  groupLabel?: string;
  groupValues: ISelector[];
}

export interface IPaginationResult<T> {
  total: number;
  current_page: number;
  prev_page_url: string;
  next_page_url: string;
  per_page: number;
  data: T;
}

export interface IUserGTMEvent {
  event: EUserAdEvent;
  subscription_type?: 'new' | 'resurrection' | 'free-trial';
  sign_up_source?: 'console';
}

export interface IUserGTMPurchaseItemEvent {
  item_id: string,
  item_name: string;
}
export interface IUserGTMPurchaseSubscriptionEvent extends IUserGTMEvent {
  internal_user_id: string;
  user_id?: string;
  event_category: string;
  transaction_id?: number;
  currency?: string;
  coupon?: string;
  event_label?: string;
  value: number;
  subscription_source: string;
  sub_type: string;
  is_trial: boolean;
  subscription_length: string;
  items: IUserGTMPurchaseItemEvent[];
}

interface Window {
  fbq: Function;
  ga: Function;
  gtag: Function;
  uetq: any[];
  dataLayer: any[];
  turnstile: Function;
}

const win = (window as any) as Window;

export default class UtilHelper {
  static dateIsFuture(date: Date | Moment, dateToCompare: Date | Moment = moment().toDate()) {
    return moment(date).diff(moment(dateToCompare)) > 0;
  }

  static dateToHumanReadable(date: Date | Moment) {
    return moment(date).format('DD MMM YYYY');
  }

  static trackAdEvent(event: EUserAdEvent) {
    this.trackBingEvent(event);
    this.trackFbPixel(event);
  }

  static trackBingEvent(event: EUserAdEvent) {
    win.uetq = win.uetq || [];
    const bingConversionEvents = {
      event_category: event, event_label: event,
    };

    win.uetq.push('event', 'AdsAction', bingConversionEvents);
  }

  static trackFbPixel(event: EUserAdEvent) {
    if (typeof win.fbq === 'function') {
      win.fbq('trackCustom', event);
    }
  }

  static trackGTMEvent(params: IUserGTMEvent | IUserGTMPurchaseSubscriptionEvent) {
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push(params);
  }

  static escapeHtml(html: string): string {
    return html
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
